export enum PageFace {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  DISABLED = 'disabled'
}
